module.exports = __webpack_public_path__ + "img/social_youtube.34158649.svg";